module.exports = __webpack_public_path__ + "img/动态模版3.a57f8abc.png";